<template>
  <div class="flex flex-col max-w-6xl mx-auto px-6 py-8">
    <div>
      <div>
        <h1
          class="text-xl text-left text-gray-700 font-medium"
        >แผนภูมิแสดงสัดส่วนความเสี่ยงในแต่ละระดับ</h1>
        <p class="text-left">จากการทำแบบทดสอบ {{assessmentResults.length}} ครั้ง</p>
      </div>

      <highcharts class="mt-4" :options="chartOptions"></highcharts>
    </div>

    <div class="mt-8">
      <div>
        <h1 class="text-left text-xl text-gray-700 font-medium">รายการคัดกรองความเสี่ยง</h1>

        <p class="block md:hidden">สามารถปัดหน้าจอไปทางด้านซ้ายเพื่อดูข้อมูลเพิ่มเติม</p>
      </div>

      <div class="mt-4 -my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="align-middle min-w-ful shadow-md border border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >ครั้งที่</th>
                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >วันที่</th>
                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >ผลการคัดกรอง</th>

                <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(result,index) in assessmentResults"
                :key="result.key"
                class="bg-white cursor-pointer"
                @click="$router.push({path: `/risk-assessment/${result.id}`})"
              >
                <td
                  class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-500"
                >{{assessmentResults.length - index}}</td>
                <td
                  class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                >{{ result.formatted_created_at }}</td>
                <td
                  class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                >{{result.final_result}}</td>

                <td class="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5 font-medium">
                  <router-link
                    :to="`/risk-assessment/${result.id}`"
                    href="#"
                    class="text-primary hover:text-indigo-900 focus:outline-none focus:underline"
                  >ดูรายละเอียด</router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import RiskCountPieChart from "../components/charts/RiskCountPieChart";
import BarChart from "../components/charts/BarChart";
import NonNumericBarChart from "../components/charts/NonNumericBarChart";
import collect from "collect.js";
import { Chart } from "highcharts-vue";

export default {
  components: {
    "risk-count-pie-chart": RiskCountPieChart,
    "bar-chart": BarChart,
    "non-numeric-bar-chart": NonNumericBarChart,
    highcharts: Chart
  },
  async created() {
    let loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer
    });

    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/risk-assessment`,
        headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
      });

      this.assessmentResults = response.data.map(assessment => {
        assessment.rawResult = JSON.parse(assessment.raw_result);
        return assessment;
      });

      loader.hide();
    } catch (error) {
      console.log(error);

      loader.hide();
    }
  },
  data() {
    return {
      assessmentResults: []
    };
  },
  computed: {
    finalResults() {
      return this.assessmentResults.map(result => result.final_result);
    },

    chartOptions() {
      let riskLevels = [
        "ความเสี่ยงต่ำ",
        "ความเสี่ยงปานกลาง",
        "ความเสี่ยงสูง",
        "ความเสี่ยงสูงปานกลาง",
        "ความเสี่ยงสูงมาก"
      ];

      return {
        chart: {
          type: "column"
        },
        title: {
          text: ""
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          title: "test",
          labels: {
            formatter: function() {
              const labels = [
                "ความเสี่ยงต่ำ",
                "ความเสี่ยงปานกลาง",
                "ความเสี่ยงสูง",
                "ความเสี่ยงสูงปานกลาง",
                "ความเสี่ยงสูงมาก"
              ];

              return labels[this.pos - 1];
            }
          }
        },
        xAxis: {
          reversed: true,
          labels: {
            formatter: function(label) {
              return label.value + 1;
            }
          }
        },

        series: [
          {
            name: "ครั้ง",
            data: this.finalResults
              .map(result => riskLevels.indexOf(result) + 1)
              .reverse(),
            color: "#9E76B4",
            pointWidth: 50
          }
        ]
      };
    }
  }
};
</script>